import React, { useEffect } from 'react';
import { useLocation } from 'react-router-dom';

// context 
import { useData } from '../../context/DataProvider/DataProvider';
import LayoutProvider from '../../context/LayoutProvider/LayoutProvider';
import { useLanguage } from '../../context/LanguageProvider/LanguageProvider';

// components 
import { App } from '../../components';
import Header from "../../components/Header"
import Footer from '../../components/Footer/Footer';
import NioBackTop from '../../components/NioBackTop/NioBackTop';
import NioStickyBadge from '../../components/NioStickyBadge/NioStickyBadge';

function AppLayout({ variant = 2, rootClass, title = 'page title goes here', titleKey, children }) {

  const data = useData();
  const location = useLocation();
  const { t } = useLanguage();

  // get navigation data 
  const navigation = data.navigation;
  const headerData = navigation.two;

  const resolvedTitle = titleKey ? t(titleKey) : title;

  useEffect(() => {
    document.title = `${resolvedTitle} - ${t('layout.docSuffix')}`;
  }, [resolvedTitle, t])

  return (
    <LayoutProvider>
      <App rootClass={rootClass}>
        <Header variant={variant} data={headerData} />
        <App.Main>
          {children}
        </App.Main>
        <Footer variant={variant} />
        <NioBackTop />
        <NioStickyBadge />
      </App>
    </LayoutProvider>
  )
}

export default AppLayout;
